//@flow
import React, {useState} from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {useMultichatFunnelActions} from '../../utils';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    alignItems: 'center',
    padding: '1rem',
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
  },
}));

type Props = {
  open: boolean,
  onClose: () => void,
};

export default function CreateFunnelModal(props: Props) {
  const {open, onClose} = props;

  const classes = useStyles();

  const [funnelName, setFunnelName] = useState('');
  const {createFunnel} = useMultichatFunnelActions();

  const handleClose = () => {
    setFunnelName('');
    onClose();
  };

  const handleSubmit = () => {
    createFunnel(funnelName).then(() => {
      handleClose();
    });
  };

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.container}>
        <Typography className={classes.title}>Nuevo proceso</Typography>
        <CustomTextField
          label="Nombre del funnel"
          value={funnelName}
          onChange={e => setFunnelName(e.target.value)}
          placeholder="Ej: Clientes Top"
        />

        <CustomButton
          variant="contained"
          onClick={handleSubmit}
          disabled={!funnelName}
        >
          Crear funnel
        </CustomButton>
      </div>
    </CustomModal>
  );
}
